import { APP_META_TRAVEL_ADS_API_ENDPOINT } from "constants/api_urls";
import axios from "axios";
import { getUserToken } from "utils/functions/userToken";

/**
 * Fetch the list of shared audiences used to populate the META_AUDIENCE dropdown
 * in the Meta Travel Ads campaign creator / editor.
 *
 * Endpoint: GET {APP_META_TRAVEL_ADS_API_ENDPOINT}/api/meta-ads/shared-audience-list/
 *
 * @param {object} [params] Optional query params (e.g. { hotel_id })
 * @returns {Promise<{success: boolean, data?: any, error?: string}>}
 */
export const getSharedAudienceList = async (params = {}) => {
    const jwtToken = getUserToken();

    try {
        const response = await axios.get(
            `${APP_META_TRAVEL_ADS_API_ENDPOINT}/api/meta-ads/shared-audience-list/`,
            {
                params,
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return { success: true, data: response.data };
    } catch (error) {
        const errorMessage =
            error?.response?.data?.errorMessage ||
            error?.message ||
            "Failed to fetch shared audience list";
        return { success: false, error: errorMessage };
    }
};

/**
 * Normalize the shared audience list response to the `{ value, label }`
 * shape consumed by `MetaAudienceForm`.
 *
 * Handles either an array response or an object response that wraps the
 * list under common keys (e.g. `audiences`, `data`, `results`).
 */
export const mapSharedAudienceListToOptions = (data) => {
    const list = Array.isArray(data)
        ? data
        : Array.isArray(data?.audiences)
            ? data.audiences
            : Array.isArray(data?.data)
                ? data.data
                : Array.isArray(data?.results)
                    ? data.results
                    : Array.isArray(data?.shared_audience_list)
                        ? data.shared_audience_list
                        : [];

    return list
        .map((item) => {
            const value = item?.audience_id ?? item?.id ?? item?.value;
            const label = item?.audience_name ?? item?.name ?? item?.label;
            if (value == null || label == null) return null;
            return { value: String(value), label: String(label) };
        })
        .filter(Boolean);
};
